var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('div',{staticClass:"lds-roller ml-3",style:(`--size: ${_vm.xxl ? 4 : .75};`)},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }